import assignmentHelper from "../../../../infrastructure/helpers/functions/assignment/assignmentHelper";
import Assignment from "../../../../types/functions/Assignment/Assignment";
import Condition from "../../../../types/functions/Condition/Condition";
import ConditionBracketState from "../ConditionBracketState";
import ConditionAndAssignmentNumber from "../Types/ConditionAndAssignmentNumber";

const resetMarkedBracketsInAssignment = (assignment: Assignment): void => {
    assignmentHelper.traverseAssignmentConditions(assignment, (condition: Condition) => {

        condition.selectedOpenBracketNumber = 0;
        condition.selectedCloseBracketNumber = 0;
        condition.hasMatchedBracket = false;

        return false;
    });
}

const findClickedCondition = (assignment: Assignment, bracketState: ConditionBracketState): ConditionAndAssignmentNumber => {

    let result = {} as ConditionAndAssignmentNumber;

    assignmentHelper.traverseAssignmentConditions(assignment, (condition: Condition, assignmentNumber: number) => {
        if (assignmentNumber === bracketState.location.assignmentNumber && condition.number === bracketState.conditionNumber) {

            result = { condition, assignmentNumber };

            return true;
        }

        return null;
    });

    return result;
}

const extractConditionsToSearch = (clickedConditionAndAssignmentNumber: ConditionAndAssignmentNumber,
    conditions: ConditionAndAssignmentNumber[],
    isOpenBracket: boolean): ConditionAndAssignmentNumber[] => {

    let resultConditions = [] as ConditionAndAssignmentNumber[];

    let foundClickedCondition = false;

    if (!isOpenBracket) {
        conditions = conditions.reverse();
    }

    for (var i = 0; i < conditions.length; i++) {

        if (foundClickedCondition) {
            resultConditions.push(conditions[i]);
        }

        if (conditions[i].assignmentNumber === clickedConditionAndAssignmentNumber.assignmentNumber &&
            conditions[i].condition.number === clickedConditionAndAssignmentNumber.condition.number) {

            foundClickedCondition = true;
        }
    }

    return resultConditions;
}

const setBracketsInAssignment = (assignment: Assignment, clickedBracketState: ConditionBracketState): void => {

    let clickedConditionAndAssignmentNumber = findClickedCondition(assignment, clickedBracketState);

    clickedConditionAndAssignmentNumber.condition.selectedOpenBracketNumber = clickedBracketState.isOpen ? clickedBracketState.number : 0;
    clickedConditionAndAssignmentNumber.condition.selectedCloseBracketNumber = !clickedBracketState.isOpen ? clickedBracketState.number : 0;

    let allConditionsWithAssignmentNumbers = assignmentHelper.getAllConditionsInAssignment(assignment);

    let searchConditions = extractConditionsToSearch(clickedConditionAndAssignmentNumber, allConditionsWithAssignmentNumbers, clickedBracketState.isOpen);

    let correspondingBracketSetSuccessfully = setCorrespondingBracket(searchConditions, clickedConditionAndAssignmentNumber, clickedBracketState);

    if (correspondingBracketSetSuccessfully) {

        clickedConditionAndAssignmentNumber.condition.hasMatchedBracket = true;
    }
    else {
        clickedConditionAndAssignmentNumber.condition.hasMatchedBracket = false;
    }
}

const setCorrespondingBracket = (conditions: ConditionAndAssignmentNumber[],
    clickedConditionAndAssignmentNumber: ConditionAndAssignmentNumber,
    clickedBracketState: ConditionBracketState): boolean => {

    let searchForNumber = 0;

    if (clickedBracketState.isOpen) {
        searchForNumber = clickedConditionAndAssignmentNumber.condition.openParentheses - clickedBracketState.number;

        if (clickedConditionAndAssignmentNumber.condition.closeParentheses > searchForNumber) {
            clickedConditionAndAssignmentNumber.condition.selectedCloseBracketNumber = searchForNumber + 1;
            clickedConditionAndAssignmentNumber.condition.hasMatchedBracket = true;
            return true;
        }
    }
    else {
        searchForNumber = clickedBracketState.number - 1;

        if (clickedConditionAndAssignmentNumber.condition.openParentheses > searchForNumber) {
            clickedConditionAndAssignmentNumber.condition.selectedOpenBracketNumber = clickedConditionAndAssignmentNumber.condition.openParentheses - searchForNumber;
            clickedConditionAndAssignmentNumber.condition.hasMatchedBracket = true;

            return true;
        }
    }

    let currentBrackets = clickedBracketState.isOpen ? clickedConditionAndAssignmentNumber.condition.openParentheses - clickedBracketState.number - clickedConditionAndAssignmentNumber.condition.closeParentheses+1 :
        clickedBracketState.number - clickedConditionAndAssignmentNumber.condition.openParentheses;

    for (var i = 0; i < conditions.length; i++) {

        if (clickedBracketState.isOpen) {
            currentBrackets += conditions[i].condition.openParentheses - conditions[i].condition.closeParentheses;
        }
        else {
            currentBrackets += conditions[i].condition.closeParentheses - conditions[i].condition.openParentheses;
        }


        if (currentBrackets <= 0) {

            if (clickedBracketState.isOpen) {
                conditions[i].condition.selectedCloseBracketNumber = conditions[i].condition.closeParentheses + currentBrackets;
            }
            else {
                conditions[i].condition.selectedOpenBracketNumber = currentBrackets * -1 + 1;
            }

            conditions[i].condition.hasMatchedBracket = true;

            return true;
        }
    }

    return false;
}

const isSameBracketClicked = (newState: ConditionBracketState, oldState: ConditionBracketState): boolean => {
    return oldState &&
        newState.number === oldState.number &&
        newState.conditionNumber === oldState.conditionNumber &&
        newState.location.statement === oldState.location.statement &&
        newState.location.assignmentNumber === oldState.location.assignmentNumber &&
        newState.location.statementNumber === oldState.location.statementNumber &&
        newState.isElseIf === oldState.isElseIf &&
        newState.isElse === oldState.isElse &&
        newState.isOpen === oldState.isOpen;
}

const findConditionWhereCloseBracketsStarts = (assignment: Assignment, clickedConditionAndAssignmentNumber: ConditionAndAssignmentNumber): ConditionAndAssignmentNumber => {

    let result = {} as ConditionAndAssignmentNumber;

    assignmentHelper.traverseAssignmentConditions(assignment, (condition: Condition, assignmentNumber: number) => {
        if (assignmentNumber === clickedConditionAndAssignmentNumber.assignmentNumber &&
            condition.number === clickedConditionAndAssignmentNumber.condition.number) {

            result = { condition, assignmentNumber };

            return true;
        }
    });

    return result;
}

export { setBracketsInAssignment, resetMarkedBracketsInAssignment, isSameBracketClicked, findConditionWhereCloseBracketsStarts }
